import { useState } from "react";
import { toast } from "sonner";
import { http } from "../lib/api";
import { useSeo } from "../lib/seo";
import { PageHero } from "../components/shop/Common";

const Field = ({ label, ...p }) => (
  <label className="block">
    <span className="text-sm font-semibold text-navy">{label}</span>
    {p.rows ? (
      <textarea {...p} className="mt-2 w-full rounded-2xl border-2 border-border px-4 py-3 outline-none focus:border-turq" />
    ) : (
      <input {...p} className="mt-2 w-full h-12 rounded-full border-2 border-border px-5 outline-none focus:border-turq" />
    )}
  </label>
);

export default function Contact() {
  const [f, setF] = useState({ name: "", email: "", order_number: "", message: "" });
  const [sent, setSent] = useState(null);
  const [busy, setBusy] = useState(false);
  useSeo({ title: "Contact Us", description: "Questions about an order, sizing or a destination request? Contact the Vacation Apparel team." });
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const r = await http.post("/contact", { ...f, order_number: f.order_number || null });
      setSent(r.data.message);
    } catch (err) {
      toast.error(err.response?.data?.detail?.[0]?.msg || "Please check the form and try again.");
    } finally {
      setBusy(false);
    }
  };
  return (
    <>
      <PageHero eyebrow="Contact" title="We'd love to hear from you" subtitle="Questions? Destination requests? Say aloha." />
      <section className="max-w-2xl mx-auto px-4 sm:px-6 py-16">
        {sent ? (
          <p className="rounded-3xl bg-turq/10 p-8 text-navy font-semibold text-lg" data-testid="contact-success">{sent}</p>
        ) : (
          <form onSubmit={submit} className="space-y-5" data-testid="contact-form">
            <Field label="Name" required value={f.name} onChange={set("name")} data-testid="contact-name-input" />
            <Field label="Email" type="email" required value={f.email} onChange={set("email")} data-testid="contact-email-input" />
            <Field label="Order number (optional)" value={f.order_number} onChange={set("order_number")} data-testid="contact-order-input" />
            <Field label="Message" rows={6} required minLength={5} value={f.message} onChange={set("message")} data-testid="contact-message-input" />
            <button disabled={busy} className="h-14 px-10 rounded-full bg-sun text-navy font-extrabold disabled:opacity-60" data-testid="contact-submit-button">
              {busy ? "Sending..." : "Send message"}
            </button>
          </form>
        )}
      </section>
    </>
  );
}
